<script>
import Cadastrar from '@/components/email/VCadastrar'

export default {
  name: 'CadastroEmail',
  components: {
    Cadastrar
  },
}
</script>

<template>
  <Cadastrar/>
</template>

<style scoped>
</style>
